import { subscribe } from "../emitter-subscriber/subscribe";
import { eventDetails } from "../event-details/event-details";
import { eventTypes } from "../types/event-types";
import { rumSend } from "../rum/rum-event";
import { getConfig, } from "../config/config-store";
import { parsePayload } from "../utils/parse";
import { getKey } from "../utils/key";
import { merge } from "../array.utils";
const createEvents = () => {
    const eventSubscription = () => {
        subscribe("AAT_EVENT_PASSIVE", (payload) => {
            let { action } = payload;
            const storeConfig = getConfig(getKey(payload));
            // const parsedPayload = storeConfig ? merge(parsePayload(payload), storeConfig) : parsePayload(payload)
            const parsedPayload = storeConfig
                ? Object.assign(Object.assign({}, merge(parsePayload(payload), storeConfig)), (action && { action })) : Object.assign(Object.assign({}, parsePayload(payload)), (action && { action }));
            rumSend(eventDetails(parsedPayload, eventTypes.journeyRecord));
        });
    };
    return { eventSubscription };
};
export const { eventSubscription } = createEvents();



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/events/events.js
// module id = ./node_modules/@celine/passive-tracking/dist/events/events.js
// module chunks = 0